"use client";
import { motion, useScroll, useSpring } from "framer-motion";

// A thin reading-progress bar pinned to the very top of the viewport. Its width
// tracks how far down the whole page has been scrolled.
const TeamProgressBar = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    mass: 0.3,
  });

  return (
    <motion.div
      aria-hidden
      style={{ scaleX }}
      className="fixed inset-x-0 top-0 z-50 h-1 origin-left bg-primary"
    />
  );
};

export default TeamProgressBar;
